module.exports = __webpack_public_path__ + "img/print-logo.33481d2f.png";